import WavesurferPlayer from '@wavesurfer/react';
import { Button, Space, Spin } from 'antd';
import { useS3Download } from 'lib/s3';
import { Download, Pause, Play } from 'lucide-react';
import { useEffect, useState } from 'react';

const btnStyle = {
  backgroundColor: '#ff0000',
  width: 35,
  height: 35,
  border: '1.5px solid #ffffff75',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
};

export function SpAudioPlayer({ src = null }) {
  const [wavesurfer, setWavesurfer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isError, setIsError] = useState(false);
  const [audioSrc, setAudioSrc] = useState('');

  const { mutateAsync, isPending } = useS3Download();

  const onReady = (ws) => {
    setWavesurfer(ws);
    setIsPlaying(false);
  };

  const onPlayPause = () => {
    wavesurfer && wavesurfer.playPause();
  };

  useEffect(() => {
    if (src?.file_name) {
      mutateAsync({
        fileExtension: src?.file_extension || 'wav',
        fileName: src?.file_name,
        module: 'online_scam',
        group: 'voice',
      })
        .then((res) => {
          setIsError(false);
          setAudioSrc(res?.body?.url);
        })
        .catch(() => {
          setIsError(true);
        });
    }
  }, [src]);

  if (!src) {
    return null;
  }

  return (
    <Spin spinning={isPending}>
      <Space size={5}>
        <WavesurferPlayer
          height={60}
          width={200}
          waveColor="#fff"
          url={audioSrc}
          onReady={onReady}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        />

        {!isError && (
          <Button type="button" style={btnStyle} onClick={onPlayPause}>
            {!isPlaying ? <Play /> : <Pause />}
          </Button>
        )}

        {!isError && (
          <Button type="button" style={btnStyle} onClick={() => window.open(audioSrc, '_blank')}>
            <Download />
          </Button>
        )}
      </Space>
    </Spin>
  );
}
